import { ReactNode, useRef } from "react";
import { createPortal } from "react-dom";

import useOnClickOutside from "@/hooks/ui/useClickOutside";

import { twMerge } from "tailwind-merge";

type Props = {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  containerClassname?: string;
  shouldCloseModalOnClickOutside?: boolean;
  onClose: () => void;
  onMouseUp?: (e: React.MouseEvent) => void;
};

const Modal = ({
  isOpen,
  children,
  className,
  containerClassname,
  shouldCloseModalOnClickOutside = true,
  onClose,
  onMouseUp
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onClose, [], shouldCloseModalOnClickOutside);

  const rootElement = document.getElementById("overlays");
  if (!isOpen || !rootElement) return null;

  return createPortal(
    <div
      className={twMerge("modal", className)}
      data-testid="modal"
      onMouseUp={onMouseUp}
    >
      <div className={twMerge("modal-content", containerClassname)} ref={ref}>
        {children}
      </div>
    </div>,
    rootElement
  );
};

export default Modal;
